var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-file-input',{directives:[{name:"validate",rawName:"v-validate",value:({
        required: !!_vm.identityInfoType,
    }),expression:"{\n        required: !!identityInfoType,\n    }"}],class:{
        'is-invalid': _vm.errors.has('document scan copy'),
    },attrs:{"input-id":"identity","input-label":"DOCUMENT SCAN COPY","placeholder":_vm.originalFileName,"drop-placeholder":"Drop file here...","file-type":"identity","accept":"image/*","disabled":!_vm.identityInfoType,"data-vv-name":"document scan copy"},on:{"update:originalFileName":_vm.updateOriginalFileName},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }